module.exports = __webpack_public_path__ + "img/modszertan-table.b7a9c321.jpg";